import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { ContentCta } from '../types/contentCta';
import { Movie } from '../types/movie';
import { msgs } from './messages';

export function useExtraContentCTAs(movies: Movie[]) {
  const intl = useIntl();

  const interestingContentCta: ContentCta = useMemo(
    () => ({
      type: 'interesting-content',
    }),
    [],
  );

  const membotCtaIndex = useMemo(() => {
    const lastCtaIndex = movies.findLastIndex(m => !!m.immerseCta);
    const moviesAfterLast = movies.length - lastCtaIndex - 1;

    if (moviesAfterLast < 2) {
      return null;
    }

    return Math.min(lastCtaIndex + 3, lastCtaIndex + Math.ceil(moviesAfterLast / 2));
  }, [movies]);

  const membotCta: ContentCta = useMemo(
    () => ({
      type: 'membot',
      ctaText: intl.formatMessage(msgs.membotCtaText),
      membotSlug: 'talking-about-a-film',
      ...(membotCtaIndex === null
        ? null
        : {
            backAnchor: movies[Math.min(membotCtaIndex + 1, movies.length - 1)].slug,
          }),
    }),
    [intl, membotCtaIndex, movies],
  );

  const interestingContentCtaIndex = useMemo(() => {
    if (!membotCtaIndex) {
      return movies.length - 1;
    }

    return Math.min(membotCtaIndex + 3, movies.length - 1);
  }, [membotCtaIndex, movies]);

  return {
    membotCta,
    membotCtaIndex,
    interestingContentCta,
    interestingContentCtaIndex,
  };
}
